import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
// import FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
// import { useFormik } from "formik";
import { useFormik, FormikProvider, FieldArray } from "formik";
// import * as Yup from "yup";
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery"; import Swal from "sweetalert2";

const ProductionOutputEdit = () => {
  let { id } = useParams();
  const [ordersLists, setOrdersLists] = useState([]);
  const [packagingTypesLists, setPackagingTypesLists] = useState([]);
  const [palletsTypesLists, setPalletsTypesLists] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  //const [backendSuccess, setBackendSuccess] = useState(null);
  const [showTableHeadings, setShowTableHeadings] = useState(true);
  const [productLists, setproductLists] = useState([]);
  const [gnnLists, setGnnLists] = useState([]);
  const [permission, setPermission] = useState({});
  let season_id = localStorage.getItem("season_id");
  const [orderboxesweight, setOrderboxesweight] = useState({});

  const [valueContents, setValueContents] = useState([]);
  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  const [value, setValue] = useState({});

  const formik = useFormik({
    initialValues: {
      id: id,
      barcode_number:value.barcode_number,
      season_id: season_id,
      date_time: value.date_time,
      location: value.location,
      shift: value.shift,
      shift_date: value.shift_date,
      calibre: value.calibre,
      packaging_type: value.packaging_type,
      number_of_boxes: value.number_of_boxes,
      net_weight: value.net_weight,
      pallet_type: value.pallet_type,
      remark: value.remark,
      order: value.order,
      ggn_number: value.ggn_number,
      contents: valueContents,


    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      const totalBoxes = values.contents.reduce((sum, item) => {
        return sum + parseInt(item.number_of_boxes || 0);
      }, 0);

      const total_gross_weight = values.contents.reduce((sum, item) => {
        return sum + parseFloat(item.gross_weight || 0);
      }, 0);

      const total_net_weight = values.contents.reduce((sum, item) => {
        return sum + parseFloat(item.net_weight || 0);
      }, 0);

      // 🚨 VALIDATION CHECKS
      let alert_messages = [];

      // Box count validation
      if (orderboxesweight.number_of_boxes > 0 && orderboxesweight.number_of_boxes != totalBoxes) {
        alert_messages.push("The Number of Boxes inserted is incorrect");
      }

      // Gross weight validation
      if (total_gross_weight < orderboxesweight.min_gross_weight && orderboxesweight.min_gross_weight > 0) {
        alert_messages.push(`The gross weight inserted is below minimum: ${orderboxesweight.min_gross_weight}`);
      }
      if (total_gross_weight > orderboxesweight.max_gross_weight && orderboxesweight.max_gross_weight > 0) {
        alert_messages.push(`The gross weight inserted is exceeds maximum: ${orderboxesweight.max_gross_weight}`);
      }

      // Net weight validation
      if (total_net_weight < orderboxesweight.min_net_weight && orderboxesweight.min_net_weight > 0) {
        alert_messages.push(`The net weight inserted is below minimum: ${orderboxesweight.min_net_weight}`);
      }
      if (total_net_weight > orderboxesweight.max_net_weight && orderboxesweight.max_net_weight > 0) {
        alert_messages.push(`The net weight inserted is exceeds maximum: ${orderboxesweight.max_net_weight}`);
      }
      // 🚨 SHOW ALERT IF ANY VALIDATION FAILS
      if (alert_messages.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Validation Error",
          html: alert_messages.map(msg => `<p>${msg}</p>`).join(''),
          customClass: {
            popup: 'my-swal-popup',
            title: 'my-swal-title',
            htmlContainer: 'my-swal-text boxes-pop-contain',
            confirmButton: 'my-swal-btn'
          }
        }).then((result) => {
          // When user clicks OK or closes the alert, submit the form
          if (result.isConfirmed || result.isDismissed) {
            axios.post("/production-output/update", values, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
              .then((response) => {
                setSubmitting(false);
                delete backendErrors['error'];
                $("#form-submit").text("Update Production Output");

                if (response.data.code === 200) {
                  // toast.success(response.data.message);
                  // setTimeout(() => {
                  //   window.location.href = "/production-output";
                  // }, 1000);
                   // toast.success(response.data.message);
                  // setTimeout(() => {
                  //   window.location.href = "/production-output";
                  // }, 1000);
                  var productions_output_id = values.id;
                  var barcode_number = values.barcode_number;

                  let season_id = localStorage.getItem("season_id");
                  axios.get(`/production-output/pdf/${season_id + '-' + productions_output_id}`, {
                    responseType: 'blob',
                    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
                  }).then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    let file_name = barcode_number + '.pdf';
                    link.download = file_name;
                    link.click();
                    setSubmitting(false);
                    toast.success(response.data.message);
                    //setBackendSuccess(response.data.message);
                    setTimeout(() => {
                      window.location.href = "/production-output";
                    }, 1000);
                  })
                    .catch(error => {
                      console.error('Error downloading PDF:', error);
                    });
                } else if (response.data.code === 422) {
                  setBackendErrors(response.data.error);
                } else if (response.data.code === 401) {
                  setBackendErrors(response.data.error);
                } else {
                  setBackendErrors(response.data.error);
                }
              })
              .catch((error) => {
                setSubmitting(false);
                toast.error(error.message || "An error occurred");
              });
          }
        });

        return;
      }

      // If no validation errors, submit normally
      axios.post("/production-output/update", values, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
        .then((response) => {
          setSubmitting(false);
          delete backendErrors['error'];
          $("#form-submit").text("Update Production Output");

          if (response.data.code === 200) {
            // toast.success(response.data.message);
            // setTimeout(() => {
            //   window.location.href = "/production-output";
            // }, 1000);
            var productions_output_id = values.id;
            var barcode_number = values.barcode_number;

            let season_id = localStorage.getItem("season_id");
            axios.get(`/production-output/pdf/${season_id + '-' + productions_output_id}`, {
              responseType: 'blob',
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
            }).then(response => {
              const blob = new Blob([response.data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              let file_name = barcode_number + '.pdf';
              link.download = file_name;
              link.click();
              setSubmitting(false);
              toast.success(response.data.message);
              //setBackendSuccess(response.data.message);
              setTimeout(() => {
                window.location.href = "/production-output";
              }, 1000);
            })
              .catch(error => {
                console.error('Error downloading PDF:', error);
              });
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          } else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          } else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          setSubmitting(false);
          toast.error(error.message || "An error occurred");
        });

    },
  });



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  useEffect(() => {
    setPermission(FindModuleById(51));
    console.log(permission);


    axios.post("/products/listing-category-type", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, }
    ).then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.products;
        let productslisting = products.map((customer, index) => ({
          label: customer.productname,
          value: customer.id,
          key: `address-${index}`,
        }));
        setproductLists(productslisting);

      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`/production-output/edit/${season_id + '-' + id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          toast.error(response.data.data.production);
          setValue(response.data.data.production);
          setValueContents(response.data.data.production.items);
          const palletType = response.data.data.production.pallet_type;
          const packaging_type = response.data.data.production.packaging_type;
          console.log('Pallet Type:', palletType, 'Type:', typeof palletType, 'As Number:', Number(palletType));
          if ([4, 5, 6].includes(Number(palletType))) {
            $(".caliber-column").css("display", 'none');
          } else {
            $(".caliber-column").css("display", 'contents');
          }

          if (response.data.data.production.pallet_type == 3) {



            response.data.data.production.items.forEach((_, index) => {
              $("#caliber-input-" + index).attr("required", true);
              console.log('required' + index);
            });
            var para = { season_id: season_id, order_id: response.data.data.production.order };
            axios
              .post("/orders/listing-confirmed-in-production-current", para, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                if (response.data.code === 200) {
                  let orders = response.data.data.orders;

                  let orderlisting = orders.map((ord, index) => ({
                    label: ord.po_number,
                    value: ord.id,
                    key: `order-${index}`,
                  }));
                  setOrdersLists(orderlisting);
                } else {
                  console.log("API response is not an array");
                }
              })
              .catch((error) => {
                console.log(error);
              });


            const order_id = response.data.data.production.order;
            axios
              .get(`/production-output/gnn-by-order/${season_id + '-' + order_id}`, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                if (response.data.code === 200) {
                  let orders = response.data.data.numbers;

                  let orderlisting = orders.map((ord, index) => ({
                    label: ord.ggn_number,
                    value: ord.ggn_number,
                    key: `order-${index}`,
                  }));
                  setGnnLists(orderlisting);
                } else {
                  console.log("API response is not an array");
                }
              })
              .catch((error) => {
                console.log(error);
              });

            axios.get(`/production-output/packaging-by-order/${season_id + '-' + order_id}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
              .then((response) => {
                if (response.data.code === 200) {
                  let orders = response.data.data.types;

                  let materials_payment_statuslisting = Object.entries(orders).map(
                    ([key, ord], index) => ({
                      label: ord.title,
                      value: ord.id,
                      key: `order-${key} - ${index}-`,
                    })
                  );
                  console.log("materials_payment_statuslisting");
                  console.log(materials_payment_statuslisting);
                  setPackagingTypesLists(materials_payment_statuslisting);

                  const result = materials_payment_statuslisting.find(
                    item => item.value == packaging_type
                  );
                  let packaging_type_label = result?.label || '';
                  console.log("packaging_type_label"); console.log(packaging_type_label);
                  axios
                    .get(`/production-output/boxes-verifing-by-order-packaging/${season_id + '-' + order_id + '-' + packaging_type_label}`, {
                      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                    })
                    .then((response) => {
                      if (response.data.code === 200) {
                        let result = response.data.data.result;
                        setOrderboxesweight(result);
                        console.log("BOXES: ", result); // ✅ Better to log the object itself
                      } else {
                        console.log("API response is not successful");
                      }
                    })
                    .catch((error) => {
                      console.log("Error fetching packaging data:", error);
                    });

                  console.log(packaging_type_label);

                } else {
                  console.log("API response is not an array");
                }
              })
              .catch((error) => {
                console.log(error);
              });

          } else {
            console.log("error");

          }
        }
      })
      .catch((error) => {
        console.log(error);
      });


  }, [id]);

  const getCustomerGNN = (order_id) => {

    //const order_id = event.target.value;
    axios
      .get(`/production-output/gnn-by-order/${season_id + '-' + order_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let orders = response.data.data.numbers;

          let orderlisting = orders.map((ord, index) => ({
            label: ord.ggn_number,
            value: ord.ggn_number,
            key: `order-${index}`,
          }));
          setGnnLists(orderlisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`/production-output/packaging-by-order/${season_id + '-' + order_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let orders = response.data.data.types;

          let materials_payment_statuslisting = Object.entries(orders).map(
            ([key, ord], index) => ({
              label: ord.title,
              value: ord.id,
              key: `order-${key} - ${index}-`,
            })
          );
          console.log(materials_payment_statuslisting);
          setPackagingTypesLists(materials_payment_statuslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`/production-output/boxes-verifing-by-order/${season_id + '-' + order_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let result = response.data.data.result;
          setOrderboxesweight(result);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }

  useEffect(() => {
    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let productslisting = response.data.data.locations;

          //let farmers = response.data.data.farmers;
          let locations = productslisting.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farmer-${index}`,
          }));

          setLocationLoading(locations);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });


    axios
      .get("/helpers/production-output-packaging-types-packaging", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let materials_payment_status =
            response.data.data.materials_payment_status;
          let materials_payment_statuslisting = materials_payment_status.map(
            (ord, index) => ({
              label: ord.title,
              value: ord.id,
              key: `order-${index}`,
            })
          );
          setPackagingTypesLists(materials_payment_statuslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get("/helpers/production-output-pallets-types", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let materials_payment = response.data.data.materials_payment_status;
          let materials_payment_listing = materials_payment.map(
            (ord, index) => ({
              label: ord.title,
              value: ord.id,
              key: `order-${index}`,
            })
          );
          setPalletsTypesLists(materials_payment_listing);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const getConfirmedOrders = (id) => {
    //const id = event.target.value;

    if (id == 3) {
      var para = { season_id: season_id, order_id: id };
      axios
        .post("/orders/listing-confirmed-in-production-current", para, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            let orders = response.data.data.orders;

            let orderlisting = orders.map((ord, index) => ({
              label: ord.po_number,
              value: ord.id,
              key: `order-${index}`,
            }));
            setOrdersLists(orderlisting);
          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    else {
      axios
        .get("/helpers/production-output-packaging-types-packaging", {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            let materials_payment_status =
              response.data.data.materials_payment_status;
            let materials_payment_statuslisting = materials_payment_status.map(
              (ord, index) => ({
                label: ord.title,
                value: ord.id,
                key: `order-${index}`,
              })
            );
            setPackagingTypesLists(materials_payment_statuslisting);
            formik.setFieldValue("packaging_type", value.packaging_type);

          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
      setOrdersLists([]);
      setGnnLists([]);
    }


  };


  const deleteItemFromDB = (item_id) => {
    const response_data = {};
    response_data.status = 'false';
    axios.get(`/production-output/delete-item/${season_id + '-' + item_id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        response_data.status = 'ok';
        return response_data;
      }
    }).catch((error) => {
      console.log(error);

      response_data.status = 'false';

    });
    return response_data;
  };


  const validateCalibreRequired = (palletType) => {
    // const palletType = event.target.value;

    formik.values.contents.forEach((_, index) => {
      if (palletType == 3) {
        $("#caliber-input-" + index).attr("required", true);
      } else {
        $("#caliber-input-" + index).removeAttr("required");
      }
    });

    if (palletType == 4 || palletType == 5 || palletType == 6) {
      $(".caliber-column").css("display", 'none');
    } else {
      $(".caliber-column").css("display", 'contents');
    }
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };


  const handleDateTimeChange = (e) => {
    const value = e.target.value;
    formik.setFieldValue("date_time", value);

    const { shift, shiftDate } = calculateShift(value);
    formik.setFieldValue("shift", shift);
    formik.setFieldValue("shift_date", shiftDate);
  };

  // Helper: Calculate shift and shift date
  // function calculateShift(dateValue) {
  //   const dateObj = new Date(dateValue);
  //   const hours = dateObj.getHours();
  //   const minutes = dateObj.getMinutes();
  //   const timeInMinutes = hours * 60 + minutes;

  //   const shift1Start = 8 * 60 + 30;  // 08:30 (510 minutes)
  //   const shift1End = 19 * 60;        // 19:00 (1140 minutes)
  //   const shift2Start = 20 * 60 + 30; // 20:30 (1230 minutes)
  //   const shift2End = 7 * 60;         // 07:00 (420 minutes)

  //   let shift = "";
  //   let shiftDate = dateValue.split("T")[0]; // default same day

  //   if (timeInMinutes >= shift1Start && timeInMinutes <= shift1End) {
  //     // Shift 1: 8:30 AM to 7:00 PM (same day)
  //     shift = 1;
  //   } else if (timeInMinutes >= shift2Start || timeInMinutes <= shift2End) {
  //     // Shift 2: 8:30 PM to 7:00 AM (next day)
  //     shift = 2;
  //     // If time is between midnight and 7:00 AM, use previous date
  //     if (timeInMinutes <= shift2End) {
  //       const prevDate = new Date(dateObj);
  //       prevDate.setDate(prevDate.getDate() - 1);
  //       shiftDate = prevDate.toISOString().split("T")[0];
  //     }
  //   }
  //   // else: gap between 7:01 PM and 8:29 PM (no shift assigned)

  //   return { shift, shiftDate };
  // }
  function calculateShift(dateValue) {
    const dateObj = new Date(dateValue);

    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      console.error("Invalid date:", dateValue);
      return { shift: "", shiftDate: "" };
    }

    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const timeInMinutes = hours * 60 + minutes;

    const shift1Start = 8 * 60 + 30;  // 08:30
    const shift1End = 19 * 60;        // 19:00
    const shift2Start = 20 * 60 + 30; // 20:30
    const shift2End = 7 * 60;         // 07:00

    let shift = "";

    // Get the date in YYYY-MM-DD format
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    let shiftDate = `${year}-${month}-${day}`;

    if (timeInMinutes >= shift1Start && timeInMinutes <= shift1End) {
      shift = 1;
    } else if (timeInMinutes >= shift2Start || timeInMinutes <= shift2End) {
      shift = 2;

      // If time is between 00:00 and 07:00, subtract 1 day
      if (timeInMinutes <= shift2End) {
        const prevDate = new Date(dateObj);
        prevDate.setDate(prevDate.getDate() - 1);
        const prevYear = prevDate.getFullYear();
        const prevMonth = String(prevDate.getMonth() + 1).padStart(2, '0');
        const prevDay = String(prevDate.getDate()).padStart(2, '0');
        shiftDate = `${prevYear}-${prevMonth}-${prevDay}`;
      }
    }

    console.log("Input:", dateValue, "| Time:", `${hours}:${minutes}`, "| Shift:", shift, "| Date:", shiftDate);

    return { shift, shiftDate };
  }


  const checkPackagingType = (packagingoption) => {

    console.log("pallet_type: " + formik.values.pallet_type);
    console.log("order: " + formik.values.order);


    if (formik.values.pallet_type == 3 && formik.values.order) {
      let packaging = packagingoption.label;
      console.log(packaging);

      axios
        .get(`/production-output/boxes-verifing-by-order-packaging/${season_id + '-' + formik.values.order + '-' + packaging}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            let result = response.data.data.result;
            setOrderboxesweight(result);
            console.log("BOXES: ", result); // ✅ Better to log the object itself
          } else {
            console.log("API response is not successful");
          }
        })
        .catch((error) => {
          console.log("Error fetching packaging data:", error);
        });
    }
  }


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Output</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-output">Production Output</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Edit Production Output
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission?.update == 1 && (
                    <div className="card-body">
                      <h4 className="card-title">Production Output</h4>
                      <FormikProvider value={formik}>
                        <form action="#" onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Date Time</label>
                                <input
                                  type="datetime-local"
                                  name="date_time"
                                  value={formik.values.date_time}
                                  className="form-input form-control input-error"
                                  // onChange={(e) => {
                                  //  formik.handleChange(e);
                                  //   customHandleInput(e);
                                  // }} 
                                  onChange={handleDateTimeChange}

                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.date_time && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date_time}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group pallet_type status">
                                <label>Palletisation Type</label>
                                {palletsTypesLists.length > 0 && (
                                  <Select

                                    className="w-100"
                                    value={palletsTypesLists.find(option => option.value == formik.values.pallet_type) || null} // Ensure correct format
                                    name="pallet_type"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("pallet_type", selectedOption);
                                      getConfirmedOrders(selectedOption.value);
                                      validateCalibreRequired(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={palletsTypesLists}
                                    placeholder="Select"


                                  />
                                )}
                                <small>
                                  {backendErrors.pallet_type && (
                                    <span className="form-error mt-1">
                                      {backendErrors.pallet_type}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            {ordersLists.length > 0 && (
                              <div className="col-md-6">
                                <div className="form-group status">
                                  <label>Order PO Number</label>

                                  <Select
                                    className="w-100"
                                    value={ordersLists.find(option => option.value == formik.values.order) || null} // Ensure correct format
                                    name="order"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("order", selectedOption);
                                      getCustomerGNN(selectedOption.value);
                                      //validateCalibreRequired(selectedOption.value); 

                                    }}
                                    onBlur={formik.handleBlur}
                                    options={ordersLists}
                                    placeholder="Select"


                                  />



                                  <small>
                                    {backendErrors.order && (
                                      <span order="form-error mt-1">
                                        {backendErrors.order}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}

                            {ordersLists.length > 0 && (
                              <div className="col-md-6">
                                <div className="form-group status">
                                  <label>GGN Number</label>
                                  <Select
                                    className="w-100"
                                    value={gnnLists.find(option => option.value == formik.values.ggn_number) || null} // Ensure correct format
                                    name="ggn_number"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("ggn_number", selectedOption);
                                      //getCustomerGNN(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={gnnLists}
                                    placeholder="Select"

                                  />

                                  <small>
                                    {backendErrors.ggn_number && (
                                      <span order="form-error mt-1">
                                        {backendErrors.ggn_number}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Shift (1 ot 2)</label>
                                <input
                                  type="text"
                                  onKeyPress={(event) => {
                                    // Allow only numbers (0-9)
                                    if (!/^[0-9]$/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  name="shift"
                                  value={formik.values.shift}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.shift && (
                                    <span className="form-error mt-1">
                                      {backendErrors.shift}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Location</label>
                                {locationLoading.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                                    name="location"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("location", selectedOption);
                                      //getCustomerGNN(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={locationLoading}
                                    placeholder="Select"



                                  />
                                )}

                                <small>
                                  {backendErrors.location && (
                                    <span className="form-error mt-1">
                                      {backendErrors.location}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Shift Date</label>
                                <input
                                  type="date"
                                  className="form-input form-control"
                                  name="shift_date"
                                  id="shift_date"
                                  value={formik.values.shift_date}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    //setDefaultDate(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}

                                />
                                <small>
                                  {backendErrors.shift_date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.shift_date}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group packaging_type status">
                                <label>Packaging Type</label>
                                <Select
                                  className="w-100"
                                  value={packagingTypesLists.find(option => option.value == formik.values.packaging_type) || null} // Ensure correct format
                                  name="packaging_type"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("packaging_type", selectedOption);
                                    checkPackagingType(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={packagingTypesLists}
                                  placeholder="Select"
                                />
                                <small>
                                  {backendErrors.packaging_type && (
                                    <span className="form-error mt-1">
                                      {backendErrors.packaging_type}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Remark</label>
                                <textarea

                                  name="remark"
                                  value={formik.values.remark}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                ></textarea>
                                <small>
                                  {backendErrors.remark && (
                                    <span className="form-error mt-1">
                                      {backendErrors.remark}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Items
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="contents"
                            render={(arrayHelpers) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  onClick={() => {
                                    //let appendArr =arrayHelpers.form.values.contents[0];
                                    let initialArr = {
                                      calibre: "",
                                      product: "",
                                      lot_number: "",
                                      number_of_boxes: "",
                                      raw_material_lot_number: '',
                                      net_weight: "",
                                      gross_weight: ""
                                    }
                                    // appendArr = (appendArr)?appendArr:initialArr;
                                    arrayHelpers.push(initialArr);
                                    setShowTableHeadings(true);

                                  }}
                                >
                                  +
                                </button>

                                <table className="table">
                                  {showTableHeadings && (
                                    <thead>
                                      <tr>
                                        <th style={{ width: '8%', display: [4, 5, 6].includes(Number(formik.values.pallet_type)) ? 'none' : 'contents' }} className="caliber-column">Caliber</th>
                                        <th style={{ width: '20%' }} >Product</th>
                                        <th style={{ width: '15%', display: [4, 5, 6].includes(Number(formik.values.pallet_type)) ? 'none' : 'contents' }} className="caliber-column">Lot Number</th>
                                        <th style={{ width: '15%' }} className="">Raw material <br />Lot Number</th>
                                        <th style={{ width: '15%' }} >Number Of Boxes</th>
                                        <th style={{ width: '15%' }} >Gross Weight</th>
                                        <th style={{ width: '15%' }} >Net Weight</th>
                                        <th style={{ width: '3%' }} ></th>
                                      </tr>
                                    </thead>
                                  )}
                                  <tbody>
                                    {formik.values.contents.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td className="caliber-column" style={{ width: '8%', display: [4, 5, 6].includes(Number(formik.values.pallet_type)) ? 'none' : 'contents' }} >
                                            <div className="form-group status">
                                              <input
                                                type="text"

                                                className={`form-input form-control ${formik.errors.contents?.[index]?.calibre && 'is-invalid'}`}
                                                id={`caliber-input-${index}`}
                                                name={`contents[${index}].calibre`}
                                                value={
                                                  formik.values.contents[index]
                                                    .calibre
                                                }
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur} // Optional: To handle blur events
                                                placeholder="Enter Caliber"
                                                required={formik.values.pallet_type === 3} // Conditionally add the required attribute

                                              />
                                            </div>
                                          </td>
                                          <td style={{ width: '20%' }}  >
                                            <div className="form-group status">
                                              {productLists.length > 0 && (
                                                <Select
                                                  name={`contents[${index}].product`}
                                                  options={productLists}
                                                  value={productLists.find(option => option.value == formik.values.contents[index].product) || null} // Ensure correct format
                                                  onChange={(selectedOption) => {
                                                    formik.setFieldValue(`contents[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                    customHandleInput({
                                                      target: {
                                                        name: `contents[${index}].product`,
                                                        value: selectedOption.value, // ✅ Ensure only value is passed
                                                      },
                                                    });
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  placeholder="Select"
                                                  className="w-100"


                                                />
                                              )}
                                            </div>
                                          </td>
                                          <td style={{ width: '15%', display: [4, 5, 6].includes(Number(formik.values.pallet_type)) ? 'none' : 'contents' }} className="caliber-column">
                                            <div className="form-group">
                                              <input
                                                type="text"
                                                placeholder="Enter Lot Number"
                                                className="form-input form-control"
                                                name={`contents[${index}].lot_number`}
                                                value={
                                                  formik.values.contents[index]
                                                    .lot_number
                                                }

                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td style={{ width: '15%' }} className="">
                                            <div className="form-group">
                                              <input
                                                type="text"
                                                placeholder="Raw material Lot Number"
                                                className="form-input form-control"
                                                name={`contents[${index}].raw_material_lot_number`}
                                                value={formik.values.contents[index].raw_material_lot_number}
                                                onChange={formik.handleChange}

                                              />
                                            </div>
                                          </td>
                                          <td style={{ width: '15%' }} >
                                            <div className="form-group">
                                              <input
                                                type="text"
                                                placeholder="Enter Boxes"
                                                className="form-input form-control"
                                                name={`contents[${index}].number_of_boxes`}
                                                value={
                                                  formik.values.contents[index]
                                                    .number_of_boxes
                                                }
                                                onKeyPress={(event) => {
                                                  if (!/^[0-9.]$/.test(event.key)) {
                                                    event.preventDefault();
                                                  }
                                                  if (event.key === '.' && event.currentTarget.value.includes('.')) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td style={{ width: '15%' }} >
                                            <div className="form-group">

                                              <div className="input-group">
                                                <input type="text"
                                                  name={`contents[${index}].gross_weight`}
                                                  value={
                                                    formik.values.contents[index]
                                                      .gross_weight
                                                  }
                                                  onKeyPress={(event) => {
                                                    if (!/^[0-9.]$/.test(event.key)) {
                                                      event.preventDefault();
                                                    }
                                                    if (event.key === '.' && event.currentTarget.value.includes('.')) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  onChange={formik.handleChange}
                                                  onBlur={formik.handleBlur}
                                                  className="form-control" placeholder="Gross Weight" aria-label="Gross Weight" aria-describedby="basic-addon2" />
                                                <div className="input-group-append">
                                                  <span className="input-group-text" id="basic-addon2">KG</span>
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                          <td style={{ width: '15%' }} >
                                            <div className="form-group">

                                              <div className="input-group">
                                                <input type="text"
                                                  name={`contents[${index}].net_weight`}
                                                  value={
                                                    formik.values.contents[index]
                                                      .net_weight
                                                  }
                                                  onKeyPress={(event) => {
                                                    if (!/^[0-9.]$/.test(event.key)) {
                                                      event.preventDefault();
                                                    }
                                                    if (event.key === '.' && event.currentTarget.value.includes('.')) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  onChange={formik.handleChange}
                                                  onBlur={formik.handleBlur}
                                                  className="form-control" placeholder="Net Weight" aria-label="Net Weight" aria-describedby="basic-addon2" />
                                                <div className="input-group-append">
                                                  <span className="input-group-text" id="basic-addon2">KG</span>
                                                </div>
                                              </div>
                                            </div>
                                          </td>




                                          <td style={{ width: '3%' }} >
                                            <div className="form-group">
                                              <button
                                                className="btn btn-danger"
                                                // style={{ marginTop: 30 }}
                                                type="button"
                                                // onClick={() =>
                                                //   arrayHelpers.remove(index)
                                                // }
                                                onClick={() => {
                                                  let item_record = formik.values.contents[index];
                                                  if (item_record.id == undefined) {
                                                    arrayHelpers.remove(index)
                                                  } else {
                                                    deleteItemFromDB(item_record.id);
                                                    arrayHelpers.remove(index)
                                                  }
                                                }}
                                              >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          />


                          <small>
                            {backendErrors.status && (
                              <span className="form-error mt-1">
                                {backendErrors.status}
                              </span>
                            )}

                            {/* {backendSuccess && (
                                    <div className="from-success mt-1">
                                      {backendSuccess}
                                    </div>
                                  )} */}
                          </small>
                          <div className="text-end mt-4">
                            <button
                              type="submit" id="form-submit"
                              className="btn btn-primary"
                              disabled={formik.isSubmitting}
                            >
                              Update Production Output
                            </button>
                          </div>
                        </form>
                      </FormikProvider>

                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionOutputEdit;
